import React from "react";
import QuestionViewState, { QuestionViewProps } from "./QuestionView.models";
import { ExamQuestionsView } from "../../../models/dtos/exams/questions/ExamQuestionsView";
import StudentAnswerView from "../../../models/dtos/exams/questions/StudentAnswerView";
import './QuestionView.scss';
import { MathJax, MathJaxContext } from "better-react-mathjax";
import { EventType } from "@testing-library/react";
import { QuestionOptions, QuestionOptionTypeString } from "../../../models/interfaces/exams/questions/QuestionOptions";
import ExamAnswerSheetModal from "../exam-answer-sheet-modal/ExamAnswerSheetModal";

export default class QuestionView extends React.PureComponent<QuestionViewProps, QuestionViewState> {

    examAnswerSheetModal: React.RefObject<ExamAnswerSheetModal>;
    constructor(props: any) {
        super(props);
        this.examAnswerSheetModal = React.createRef();
    }

    render(): React.ReactNode {
        let { question, studentAnswer, showAllQuestion, examTimeExpired, isReadyOnly } = this.props;
        let studentHasAnsweredTheQuestion = studentAnswer.filter(response => response.questionId === question.questionId).length === 1 || (isReadyOnly && question.answers.filter(answer => answer.isCorrectAnswer && answer.isWhichOption === question.studentSelectedAnswerOption));
        let studentHasAnsweredWronglyToTheQuestion = question.studentSelectedAnswerOption !== null && isReadyOnly && question.answers.filter(answer => answer.isCorrectAnswer && answer.isWhichOption !== question.studentSelectedAnswerOption);
        let isStudentSelectedRelatedQuestion = question.relatedQuestions.filter(item => studentAnswer.filter(response => response.questionId === item.questionId).length === 0).length <= 0;
        let answeredClass = studentHasAnsweredTheQuestion ? "answered questionn-Answer " : "";
        let hiddenClass = (showAllQuestion && studentHasAnsweredTheQuestion) || (showAllQuestion && question.relatedQuestions.length > 0 && isStudentSelectedRelatedQuestion) ? "d-none " : "";
        let wrongAnswerClass = studentHasAnsweredWronglyToTheQuestion ? "dangerAnswer danger-Answer" : "";
        let questionCategoryId = question.relatedQuestions.length > 0 ? question.questionId : null;
        let questionStoreId = question.relatedQuestions.length <= 0 ? question.questionId : null;

        return (<>

            <div className={"tk-card question-view-area " + (answeredClass) + (hiddenClass) + (wrongAnswerClass)}
                style={{ position: "relative" }}>
                <div className="col-12 question" >
                    {this.questionTitleView(question)}
                </div>
                <div className="col-12 tk-padding-bottom tk-padding-top">
                    {this.answerListView(question, examTimeExpired || isReadyOnly, studentAnswer)}
                </div>
                {isReadyOnly ? this.readOnlyAnswerSheetView(question) : (<></>)}

                {this.indexView(question)}

                {!isReadyOnly ? this.reportQuestionView(questionStoreId, questionCategoryId) : (<></>)}
            </div>
        </>);
    }

    reportQuestionView(questionStoreId?: number | null, questionCategoryId?: number | null) {
        return (<>
            <div onClick={() => this.props.onHandleShowQuestionReport(questionStoreId, questionCategoryId)}>
                <span className="question-report-icon mdi mdi-alert-octagram"></span>
                <span >(گزارش خرابی سوال)</span>
            </div>
        </>);
    }

    questionTitleView(question: ExamQuestionsView) {

        let indexs: (number | null | undefined)[] | null;
        let indexMoreSpace = question.index !== undefined && question.index !== null && question.index > 9;
        let content

        if (question.relatedQuestions.length > 0)
            indexs = question.relatedQuestions.filter(qu => qu.parentId === question.questionId).map(qu => qu.index);
        else indexs = null;

        if (question.questionTitle !== "") {
            content = (<div className="row question-baseline">
                <div className="question-number">
                    {question.index != null ? question.index + '-' : ''}
                </div>
                <div className={"col-10  notspace"}>
                    <span dangerouslySetInnerHTML={{ __html: question.questionTitle }}></span>
                    <br />
                    {question.relatedQuestions.length > 0 ? " - " + "سوال های " + (indexs != null ? indexs.join(" , ") : '') + " مربوط به این سوال میباشد" : ''}
                </div>
                {question.additionalAttachmentId !== undefined && question.additionalAttachmentId !== null && question.additionalAttachmentId !== "" ? (
                    <div className={"question-image-area"} onClick={() => this.props.onHandleShowQuestionImage(question.additionalAttachmentId)}>
                        <a >مشاهده عکس سوال</a>
                    </div>) : (<></>)}
            </div>)
        }
        else {
            content = (
                <div className="row">
                    <div className="question-number">
                        {question.index != null ? question.index + '-' : ''}
                    </div>
                    <div className={"col-10 notspace question-image-area"} onClick={() => this.props.onHandleShowQuestionImage(question.questionAttachmentId)}>
                        <img src={`https://cdn.barandehsaz.com/FileUploader/Download/?AttachmentID=${question.questionAttachmentId}`} className="thumb" alt="question" />
                        <a >مشاهده سوال</a>
                    </div>
                </div>)
        }

        return (<>
            {content}
        </>);
    }

    answerListView(question: ExamQuestionsView, disableInput: boolean, studentAnswer: StudentAnswerView[]) {
        let answers = question.answers;

        const config = {
            "fast-preview": {
                disabled: true
            },
            tex: {
                packages: { "[+]": ["html"] },
                inlineMath: [
                    ["$", "$"],
                    ["\\(", "\\)"]
                ],
                displayMath: [
                    ["$$", "$$"],
                    ["\\[", "\\]"]
                ],
                Macros: {
                    RR: "{\\bf R}",
                    bold: ["{\\bf #1}", 1]
                },
            },

            messageStyle: "none",

        };




        return (<>
            {answers !== null ? answers.map((answer, key) => {
                let isStudentSelectedAnswer = studentAnswer.filter(response => response.questionId === question.questionId && response.answer.isWhichOption === answer.isWhichOption).length === 1 || question.studentSelectedAnswerOption === answer.isWhichOption;
                let answerTitle;

                let answerClass = question.studentSelectedAnswerOption === answer.isWhichOption && !answer.isCorrectAnswer ? "danger" : answer.isCorrectAnswer ? "success" : "";

                if (answer.optionText !== "")
                    answerTitle = (<label className=" tk-link answer-option only-text">
                        <span className="answer-number">{question.answers.indexOf(answer) + 1} )</span>

                        <MathJaxContext version={3} config={config}>
                            <span dangerouslySetInnerHTML={{ __html: answer.optionText }}></span>
                        </MathJaxContext>

                    </label>);
                else
                    answerTitle = (<label className=" tk-link answer-option has-image">{question.answers.indexOf(answer) + 1} گزینه</label>);

                let handleClick = (e: any) => {
                    if (!this.props.isReadyOnly) {
                        e.stopPropagation();
                        e.preventDefault();
                        this.props.onHandleAnswer(question, answer);
                    }
                }

                let stopClick = (e: any) => {
                    e.stopPropagation();
                    e.preventDefault();
                }

                return <div key={key} className="answer">
                    <label className="container-Radio tk-padding-0" onClick={e => handleClick(e)}>

                        <input disabled={disableInput}
                            checked={isStudentSelectedAnswer ? true : false}
                            type="radio"
                            name={"question" + question.questionId.toString()}
                            onChange={e => stopClick(e)}
                        />
                        <span className={"checkmark-Radio " + (answerClass)}></span>
                        <span className="clearfix"></span>
                        {answerTitle}
                    </label>
                </div >
            }) : <></>}
        </>);
    }

    indexView(question: ExamQuestionsView) {
        return (<>
            <div className="FooterBound">
                <label>
                    {question.index !== null ? question.index : ''}
                </label>
            </div>
        </>);
    }

    readOnlyAnswerSheetView(question: ExamQuestionsView) {
        let answers = question.answers;
        let correctAnswer = answers.filter(answer => answer.isCorrectAnswer)[0].isWhichOption;
        let studentAnswerContent;

        if (question.studentSelectedAnswerOption !== null && question.studentSelectedAnswerOption !== undefined)
            studentAnswerContent = (<>
                <label className="selected-answer">پاسخ شما گزینه {QuestionOptionTypeString(question.studentSelectedAnswerOption)} می باشد</label>
            </>);
        else studentAnswerContent = (<>
            <label className="selected-answer">شما به این سوال پاسخ نداده اید</label>
        </>);

        return (<>

            <div className="col-12 tk-padding-top">
                <label className="selected-answer">پاسخ صحیح گزینه {QuestionOptionTypeString(correctAnswer)} می باشد</label>
                {studentAnswerContent}
                <label className="selected-answer" onClick={() => question.answerSheetAttachmentId ? this.props.onHandleShowQuestionImage(question.answerSheetAttachmentId) : this.examAnswerSheetModal.current?.openModal(question)}>جهت مشاهده پاسخنامه کلیک کنید</label>
            </div>
            <ExamAnswerSheetModal ref={this.examAnswerSheetModal} />
        </>);
    }
}